import React, { useContext, useState } from "react";
import { Backdrop } from "@mui/material";

import { PermissionContext, RolePermissions } from "../../../../../appContext";
import { PermisionDenied } from "../../common/commonComponents";
import ALoader from "views/pages/manage/common/a-loader";
import { pages } from "../../common/constant";
import ExamTable from "./ExamTable";

const ExternalExam = () => {
  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(
    permissions,
    pages["externalExam"]["id"]
  );

  const [isLoading, setIsLoading] = useState(false);

  return userPermissions ? (
    <>
      <ExamTable
        userPermissions={userPermissions}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />

      {isLoading && (
        <Backdrop
          open={isLoading}
          sx={(theme) => ({
            color: "#fff",
            zIndex: 2300,
          })}
        >
          <ALoader />
        </Backdrop>
      )}
    </>
  ) : (
    <PermisionDenied />
  );
};

export default ExternalExam;
